import { customElement, property, query, state } from 'lit/decorators';
import { css, html, LitElement, nothing, PropertyValues } from 'lit';

import '@carbon/web-components/es/icons/add/16.js';
import '@carbon/web-components/es/icons/arrow--right/16.js';
import '@carbon/web-components/es/icons/arrow--left/16.js';
import '@carbon/web-components/es/icons/arrow--up/16.js';
import '@carbon/web-components/es/icons/arrow--down/16.js';
import '@carbon/web-components/es/icons/checkmark/16.js';
import '@carbon/web-components/es/icons/close/16.js';
import '@carbon/web-components/es/icons/delete/16.js';
import '@carbon/web-components/es/icons/download/16.js';
import '@carbon/web-components/es/icons/edit/16.js';
import '@carbon/web-components/es/icons/error/16.js';
import '@carbon/web-components/es/icons/help/16.js';
import '@carbon/web-components/es/icons/information/16.js';
import '@carbon/web-components/es/icons/menu/16.js';
import '@carbon/web-components/es/icons/overflow-menu--horizontal/16.js';
import '@carbon/web-components/es/icons/overflow-menu--vertical/16.js';
import '@carbon/web-components/es/icons/save/16.js';
import '@carbon/web-components/es/icons/search/16.js';
import '@carbon/web-components/es/icons/settings/16.js';
import '@carbon/web-components/es/icons/warning/16.js';
import '@carbon/web-components/es/icons/renew/16.js';

import '@carbon/web-components/es/icons/add/20.js';
import '@carbon/web-components/es/icons/arrow--right/20.js';
import '@carbon/web-components/es/icons/arrow--left/20.js';
import '@carbon/web-components/es/icons/arrow--up/20.js';
import '@carbon/web-components/es/icons/arrow--down/20.js';
import '@carbon/web-components/es/icons/checkmark/20.js';
import '@carbon/web-components/es/icons/close/20.js';
import '@carbon/web-components/es/icons/delete/20.js';
import '@carbon/web-components/es/icons/download/20.js';
import '@carbon/web-components/es/icons/edit/20.js';
import '@carbon/web-components/es/icons/error/20.js';
import '@carbon/web-components/es/icons/help/20.js';
import '@carbon/web-components/es/icons/information/20.js';
import '@carbon/web-components/es/icons/menu/20.js';
import '@carbon/web-components/es/icons/overflow-menu--horizontal/20.js';
import '@carbon/web-components/es/icons/overflow-menu--vertical/20.js';
import '@carbon/web-components/es/icons/save/20.js';
import '@carbon/web-components/es/icons/search/20.js';
import '@carbon/web-components/es/icons/settings/20.js';
import '@carbon/web-components/es/icons/warning/20.js';
import '@carbon/web-components/es/icons/renew/20.js';

import '@carbon/web-components/es/icons/add/24.js';
import '@carbon/web-components/es/icons/arrow--right/24.js';
import '@carbon/web-components/es/icons/arrow--left/24.js';
import '@carbon/web-components/es/icons/arrow--up/24.js';
import '@carbon/web-components/es/icons/arrow--down/24.js';
import '@carbon/web-components/es/icons/checkmark/24.js';
import '@carbon/web-components/es/icons/close/24.js';
import '@carbon/web-components/es/icons/delete/24.js';
import '@carbon/web-components/es/icons/download/24.js';
import '@carbon/web-components/es/icons/edit/24.js';
import '@carbon/web-components/es/icons/error/24.js';
import '@carbon/web-components/es/icons/help/24.js';
import '@carbon/web-components/es/icons/information/24.js';
import '@carbon/web-components/es/icons/menu/24.js';
import '@carbon/web-components/es/icons/overflow-menu--horizontal/24.js';
import '@carbon/web-components/es/icons/overflow-menu--vertical/24.js';
import '@carbon/web-components/es/icons/save/24.js';
import '@carbon/web-components/es/icons/search/24.js';
import '@carbon/web-components/es/icons/settings/24.js';
import '@carbon/web-components/es/icons/warning/24.js';
import '@carbon/web-components/es/icons/renew/24.js';

import '@carbon/web-components/es/icons/add/32.js';
import '@carbon/web-components/es/icons/arrow--right/32.js';
import '@carbon/web-components/es/icons/arrow--left/32.js';
import '@carbon/web-components/es/icons/arrow--up/32.js';
import '@carbon/web-components/es/icons/arrow--down/32.js';
import '@carbon/web-components/es/icons/checkmark/32.js';
import '@carbon/web-components/es/icons/close/32.js';
import '@carbon/web-components/es/icons/delete/32.js';
import '@carbon/web-components/es/icons/download/32.js';
import '@carbon/web-components/es/icons/edit/32.js';
import '@carbon/web-components/es/icons/error/32.js';
import '@carbon/web-components/es/icons/help/32.js';
import '@carbon/web-components/es/icons/information/32.js';
import '@carbon/web-components/es/icons/menu/32.js';
import '@carbon/web-components/es/icons/overflow-menu--horizontal/32.js';
import '@carbon/web-components/es/icons/overflow-menu--vertical/32.js';
import '@carbon/web-components/es/icons/save/32.js';
import '@carbon/web-components/es/icons/search/32.js';
import '@carbon/web-components/es/icons/settings/32.js';
import '@carbon/web-components/es/icons/warning/32.js';
import '@carbon/web-components/es/icons/renew/32.js';


import Debug from 'debug';
const log = Debug('pdq:ui:pdq-icon');

@customElement('pdq-icon')
export class PdqPdfViewer extends LitElement {
  _iconFunc: any = null;
  _icon: string = '';
  @property({ type: String })
  get icon() {
    return this._icon
  }
  set icon(value: string) {
    this._icon = value;
    this._iconFunc = (import(`@carbon/web-components/es/icons/${this._icon}/${this.size}.js`) as any).default
  }
  @property({ type: Number }) size = 16;
  @property({ type: Object }) options = {};
  static styles = css``;

  render() {
    if (!this._iconFunc)
      return nothing
    return html`${this._iconFunc(this.options)}`
  }

}
